import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

import { InputPanel, InputTextBox } from '@camelot/form-model';
import { graphQlUpdateFields } from '@camelot/server';
import { getModifiedValues } from '@camelot/utils';

import { Department } from '../dto/department';
import { DepartmentCreationPayloadInput } from '../dto/department-creation-payload-input';
import { DepartmentModifierPayloadInput } from '../dto/department-modifier-payload-input';

enum EDepartmentFormFields {
  name = 'name',
}

@Injectable({
  providedIn: 'root',
})
export class CamDepartmentFormService {
  public getDepartmentForm(department: Department | null) {
    return [
      new InputPanel({
        key: 'panel',
        contentClass: 'highlight-title g-space-md',
        children: [
          new InputTextBox({
            key: EDepartmentFormFields.name,
            value: department?.name,
            label: 'organization.departments.form.name',
            validators: [Validators.required],
          }),
        ],
      }),
    ];
  }

  public departmentCreateFormatForm(data: any): DepartmentCreationPayloadInput {
    return {
      name: data[EDepartmentFormFields.name] ?? null,
    };
  }

  public departmentUpdateFormatForm(data: any, department: Department): Partial<DepartmentModifierPayloadInput> {
    const modifiedData = getModifiedValues(data, department);
    return {
      id: department.id,
      ...this.departmentCreateFormatForm(data),
      ...graphQlUpdateFields(modifiedData),
    };
  }
}
